<template>
  <div>
    <b-row class="mt-5">
      <b-col lg="4" sm="6">
        <p class="text-center fs-18 font-weight-bold text-primary">Subir documentos</p>
        <FileUploader
          :allowedFileTypes="['.xlsx', '.csv', '.pdf', '.dwg']"
          :maxFileSize="26214400"
          @file-added="createDocument"
        />
      </b-col>
      <b-col lg="8" sm="6" class="border-left" style="min-height: 19rem">
        <p class="text-center fs-18 font-weight-bold text-primary">Documentos agregados</p>
        <b-row v-if="loading" align-h="center">
          <div class="text-center text-secondary">
            <b-spinner small type="grow"></b-spinner>
            <span class="pl-2">Consultando documentos...</span>
          </div>
        </b-row>
        <b-row v-else>
          <b-col v-if="documents.length > 0">
            <b-row v-for="(doc, index) in documents" :key="doc.id">
              <b-col cols="12">
                <b-list-group>
                  <b-list-group-item>
                    <div class="d-flex justify-content-between">
                      <b-link @click="downloadDocument(doc)">{{doc.name}}</b-link>
                      <Button variant="red" @click="onDeleteClick(doc, index)">
                        <font-awesome-icon :icon="['far', 'trash-alt']" fixed-width />
                      </Button>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col v-else>
            <div class="text-center text-secondary">
              <span>No hay documentos para mostrar</span>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- CONFIRMATION: Delete-->
    <b-modal
      v-model="deleteConfirmationModal"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
    >
      <b-row align-h="center" >
        <font-awesome-icon :icon="['far', 'question-circle']"  class="text-info modal-icon" />
      </b-row>
      <b-row align-h="center">
        <b-col>
          <p class="fs-20 text-center">
            ¿Eliminar
            <span v-if="selectedDocument" class="font-weight-bold">{{ selectedDocument.name }}</span> ?
          </p>
        </b-col>
      </b-row>
      <b-row align-h="center" class="pt-2 pl-2 pr-2 text-secondary">
        <small class="text-center">NOTA: El proceso es irreversible</small>
      </b-row>
      <b-row align-h="around" class="my-4">
        <Button variant="red" @click="deleteConfirmationModal = false">No</Button>
        <Button variant="green" @click="deleteDocument()">Sí</Button>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import ToastAlert from '../../shared/ToastAlert'

import FileUploader from '../../shared/FileUploader'
import Button from '../../shared/Button'

export default {
  name: 'ItemDocuments',
  components: { FileUploader, ToastAlert, Button },
  props: {
    productId: {
      type: Number,
      required: true
    },
    documents: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      processing: false,
      deleteConfirmationModal: false,
      selectedDocument: null,
      selectedDocumentIndex: null,
    }
  },
  methods: {
    createDocument (form){
      if (this.processing) { return }
      this.processing = true
      this.$http.post(`/api/production/products/${this.productId}/documents`, {
        document: form
      })
        .then((resp) => {
          // console.log('response document:', resp);
          this.$emit('add-document', resp.data.document)
        })
        .catch((e) => {
          console.log(e)
          this.$emit('display-alert', {
            message: 'El archivo no se subió correctamente, archivos validos (.xlsx,.pdf), máximo 25MB',
            variant: 'danger'
          })
        })
        .finally(()=>{
          this.processing = false
        })
    },
    downloadDocument (doc){
      if (this.processing) { return }
      this.processing = true
      this.$http.get(`/api/production/products/${this.productId}/documents/${doc.id}/download`)
        .then((resp) => {
          // console.log(resp.data)
          const link = document.createElement('a')
          link.href = resp.data
          link.download = doc.name
          link.click()
        })
        .catch(e => console.log(e))
        .finally(this.processing = false)
    },
    onDeleteClick (doc, index){
      this.selectedDocument = doc
      this.selectedDocumentIndex = index
      this.deleteConfirmationModal = true
    },
    deleteDocument () {
      if (this.processing) { return }
      this.processing = true
      this.$http.delete(`/api/production/products/${this.productId}/documents/${this.selectedDocument.id}`)
        .then((resp) => {
          this.$emit('delete-document', this.selectedDocument.id)
        })
        .catch(e => {
          // console.log(e)
          this.$emit('display-alert', {
            message: 'No fue posible eliminar el documento, intente de nuevo',
            variant: 'danger'
          })
        })
        .finally(()=> {
          this.deleteConfirmationModal = false
          this.processing = false
        })
    }
  }
}
</script>